import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 41.9 41.7",
  width: "41.9",
  height: "57.537",
  "xml:space": "preserve"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M13.7,25.2h2.8c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.8c-0.4,0-0.8,0.3-0.8,0.8S13.3,25.2,13.7,25.2z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M13.7,18.1h2.8c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.8c-0.4,0-0.8,0.3-0.8,0.8S13.3,18.1,13.7,18.1z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M24.7,25.2h2.7c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.7c-0.4,0-0.8,0.3-0.8,0.8S24.3,25.2,24.7,25.2z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M24.7,32.3h2.7c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.7c-0.4,0-0.8,0.3-0.8,0.8S24.3,32.3,24.7,32.3z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M24.7,18.1h2.7c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.7c-0.4,0-0.8,0.3-0.8,0.8S24.3,18.1,24.7,18.1z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        d: "M41.2,13.1L1.2,0.2C0.8,0.1,0.4,0.3,0.2,0.7C0.1,1.1,0.3,1.5,0.7,1.7L4.8,3v38c0,0.4,0.3,0.8,0.8,0.8h8.2h5.5h16.4   c0.4,0,0.8-0.3,0.8-0.8V13.1l4.3,1.4c0.1,0,0.2,0,0.2,0c0.3,0,0.6-0.2,0.7-0.5C41.8,13.6,41.6,13.2,41.2,13.1z M14.5,40.2v-7.9h4   v7.9H14.5z M34.9,40.2H20v-8.7c0-0.4-0.3-0.8-0.8-0.8h-5.5c-0.4,0-0.8,0.3-0.8,0.8v8.7H6.3V3.4l28.6,9.2V40.2z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})